export default __webpack_public_path__ + "static/media/besos.1425f33b.jpg";